import React, {useEffect, useCallback, useState, useRef} from "react";
import { motion, useMotionValue, useTransform, useSpring, AnimatePresence, usePresence} from 'framer-motion';
import ProgressiveBackgroundImg from "../../components/ProgressiveBackgroundImg/ProgressiveBackgroundImg";
import { smoothScrollTo } from "../../globals/helpers";
import { deviceType, primaryInput } from 'detect-it';
import BottomFilter from "../../components/bottomFilter/BottomFilter";
import ArchiveListItem from "../../components/archiveListItem/ArchiveListItem";
import debounce from 'lodash.debounce';
import MobArchiveListItem from "../../components/MobArchiveListItem/MobArchiveListItem";
import { useNavigate } from "react-router-dom";
import MobArchiveFilters from "../../components/MobArchiveFilters/MobArchiveFilters";
import NewColourMode from "../../components/NewColourMode/NewColourMode";
import CornerComponent from "../../components/CornerComponent/CornerComponent";
import { getGutterWidth } from "../../globals/helpers";
import { projExitBgDelay, projExitBgDuration, projExitBgEase } from "./variables";
import { bgOverlayWrapperVariants, bgVariants, gridLineVertVariants, mobBannerTitleVariants, mobBgVariants, mobControlVariants, mobFilterUpperWrapperVariants, mobItemsWrapperVariants, sideCurveVariantd, svgTestVariants, vertLineGridVariants, videoVariants } from "./variants";
import LocomotiveScroll from 'locomotive-scroll';
import { projData } from "../../globals/data";
import './archive.css';



const Archive = ({location, setTriggerArchiveToHomepageTransition, setHomeToArchiveTransitionTrigger, setCursorText}) => {
    let navigate = useNavigate();
    const [isPresent, safeToRemove] = usePresence();
    const [homeExitScaler, setHomeExitScaler] = useState(null);
    const mainBgRef = useRef(null);
    const secondaryBgRef = useRef(null);

    const tlRef = useRef(null);
    const trRef = useRef(null);
    const blRef = useRef(null);
    const brRef = useRef(null);

    const [exitTargetHeight, setExitTargetHeight] = useState(null);
    const [exitTargetWidth, setExitTargetWidth] = useState(null);

    const transWiperRef = useRef(null);

    const archiveListWrapperRef = useRef(null);
    const topCurveRef = useRef(null);
    const bottomCurveRef = useRef(null);
    const rightCurveRef = useRef(null);
    const leftCurveRef = useRef(null);

    const vidBorderRef = useRef(null);
    const videoRef = useRef(null);
    const vertLeftref = useRef(null)
    const horizUpperRef = useRef(null);

    const bgScalerRef = useRef(null)
    const directBGRef = useRef(null);
    const glRef = useRef(null);
    const visBackgroundRef = useRef(null);
    const backgroundWrapperRef = useRef(null);
    const mobBackgroundWrapperRef = useRef(null)

    const leftLineRef = useRef(null);
    const rightLineRef = useRef(null);
    const upperLineRef = useRef(null);
    const bottomLineRef = useRef(null);
    const bgGradRef = useRef(null);

    const scrollRef = useRef(null);

    const mobBgControlRef = useRef(null);
    const listWrapperRef = useRef(null);
    const upperFilterBannerRef = useRef(null);

    const [isHomeExit, setIsHomeExit] = useState(false);
    const [curveTransformDelta, setCurveTransformDelta] = useState(0);
    const [gridScaler, setGridScaler] = useState([1,1]);
    const [visBgScaler, setVisBgScaler] = useState([1,1])
    const [activeIdx, setActiveIdx] = useState(0);
    const [filteredData, setFilteredData] = useState(projData);
    const [activePage, setActivePage] = useState(0);
    const [maxPages, setMaxPages] = useState(null);
    const [isScreen, setIsScreen] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const [isFirstLoad, setIsFirstLoad] = useState(true);
    const [exitScaler, setExitScaler] = useState(1);

    const bgEleRef = useRef(null);
    const bcWrapperRef = useRef(null);
    const goToUnderlinerRef = useRef(null);
    const mobileElementRefs = useRef([]);
    const toTopRef = useRef(null);

    const [scroller, setScroller ]= useState(null);
    const [isProjectExit, setIsProjectExit] = useState(false);
    const [isExiting, setIsExiting] = useState(false);
    const [mobFilterActive, setMobFilterActive] = useState(false);

    const [activeFilter, setActiveFilter] = useState(0);
    const [isColourMode, setIsColourMode] = useState(true);
    const [mousePosition, setMousePosition] = useState({left: window.innerwidth/2,top: window.innerHeight/2});
    const [mobOverlayMode, setMobOverlayMode] = useState(false);

    const [bgCornersActive, setBgCornersActive] = useState(false);

    
    const archiveElementRefs = useRef([]);
    const mouseX = useMotionValue(window.innerWidth/2);
    const mouseY = useMotionValue(window.innerHeight/2);

    // Set up inertia using spring with a damping and stiffness to simulate easing
    const inertiaX = useSpring(mouseX, { damping: 10, stiffness: 50 });
    const inertiaY = useSpring(mouseY, { damping: 10, stiffness: 50 });

    const inertiaX_2 = useSpring(mouseX, { damping: 5, stiffness: 50 });
    const inertiaY_2 = useSpring(mouseY, { damping: 5, stiffness: 50 });

    // Transform motion values to create parallax effect for each element
    const parallaxX = useTransform(inertiaX, (x) => (x - window.innerWidth / 2) / window.innerWidth * 50);
    const parallaxY = useTransform(inertiaY, (y) => (y - window.innerHeight / 2) / window.innerHeight * 35);
    const rotateY = useTransform(inertiaX, (x) => (2*((x / window.innerWidth) - 0.5)) * 10)  // does left and right
    const rotateX = useTransform(inertiaY, (y) => (2*((y / window.innerHeight) - 0.5)) * 10) // does up and down

    const parallaxX_2 = useTransform(inertiaX_2, (x) => (x - window.innerWidth / 2) / window.innerWidth * 500);
    const parallaxY_2 = useTransform(inertiaY_2, (y) => (y - window.innerHeight / 2) / window.innerHeight * 350);
    const rotateY_2 = useTransform(inertiaX_2, (x) => (2*((x / window.innerWidth) - 0.5)) * 10)  // does left and right
    const rotateX_2 = useTransform(inertiaY_2, (y) => (2*((y / window.innerHeight) - 0.5)) * 10) // does up and down

    const mobScrollRef = useRef(null);


    useEffect(() => {
        try{
        if(mobBackgroundWrapperRef.current){
            if(mobOverlayMode){
                mobBackgroundWrapperRef.current.style.zIndex = 1;
                toTopRef.current.style.opacity = 0.35;
                toTopRef.current.style.filter = "blur(4px)"
            } else{
                mobBackgroundWrapperRef.current.style.zIndex = -1;
                toTopRef.current.style.opacity = 1;
                toTopRef.current.style.filter = "blur(0px)"
            }
        }}catch{}
    }, [mobOverlayMode])

    function handleMouseMove(e){
        if(isPresent && primaryInput == "mouse"){
            mouseX.set(e.pageX);
            mouseY.set(e.pageY);
            setMousePosition({e: e});
        }
    }   

    // resize handler
    function responsiveResize(){
        // fillers need resizing too
        let curWidth = window.innerWidth;
        if (curWidth < 600){
            // break to mobile view
            setIsMobile(true);
        } else if(curWidth > 775){
            let targetWidth = (window.innerWidth - (getGutterWidth(window.innerWidth).main *2))
            let tmpHeight = Math.min(targetWidth * (9/16), window.innerHeight - 180)

            let bgElementPosInfo = mainBgRef.current.getBoundingClientRect();
            let bgheight = bgElementPosInfo.height;
            let bgTop = bgElementPosInfo.top;
            
            let curveTransformDelta = (window.innerHeight/2) - (tmpHeight/2) - 60;
            setCurveTransformDelta(curveTransformDelta);

            let bgScaler = [targetWidth/visBackgroundRef.current.offsetWidth, tmpHeight/visBackgroundRef.current.offsetHeight]
            setVisBgScaler(bgScaler);

            let newGridScaler = [targetWidth/glRef.current.offsetWidth, tmpHeight/glRef.current.offsetHeight];
            setGridScaler(newGridScaler);
        }
    }

    useEffect(() => {
        if(activeFilter == 0){
            setActiveIdx(0)
            setFilteredData(projData);
        } else{
            for(let i=0; i<projData.length; i++){
                if(projData[i].tags.includes(activeFilter)){
                    setActiveIdx(i);
                    return;
                }
            }
        }
    }, [activeFilter])

    useEffect(() => {
        if(isMobile){
            if(!isColourMode){
                bgEleRef.current.style.filter = "grayscale(1) invert(1)";
            }else{
                bgEleRef.current.style.filter = "grayscale(0) invert(0)";
            }
        }
    }, [isColourMode])

    // Handles changes to the isPresent state
    // This is from framer-motion & is used to detect when a component is dismounting from the DOM
    // By listening to changes, we can detect when the Archive page is dismounting and block removal of elements until
    // the given animations have taken place
    useEffect(() => {
        try{
            if(!isPresent){
                if(window.location.href.includes("projects")){
                    setIsProjectExit(true);
                    setIsExiting(true);

                    if(!isMobile){
                        setTimeout(() => {
                            // Scale the background element wrapper up to a given fixed width - 100% - some margin
                            // Only should do this if moving to the project page though, need to detect on this
                            let translateToTop;
                            let targetWidth = (window.innerWidth - (getGutterWidth(window.innerWidth).main *2));
                            let targHeight = Math.min(targetWidth * (9/16), window.innerHeight - 180)
                            if(visBackgroundRef.current){
                                visBackgroundRef.current.style.transition = `transform ${projExitBgDuration}s cubic-bezier(${projExitBgEase[0]}, ${projExitBgEase[1]}, ${projExitBgEase[2]}, ${projExitBgEase[3]})`;
                                translateToTop = (window.innerHeight/2 - 60)
                                visBackgroundRef.current.style.transform = `translateY(-${translateToTop}px) scale3d(${visBgScaler[0]}, ${visBgScaler[1]}, 1) translateX(-50%)`
                            }

                            if(glRef.current){
                                glRef.current.style.transition = `transform ${projExitBgDuration}s cubic-bezier(${projExitBgEase[0]}, ${projExitBgEase[1]}, ${projExitBgEase[2]}, ${projExitBgEase[3]})`;
                                let gridTransform = (window.innerHeight/2 - 60) - targHeight/2 ;
                                glRef.current.style.transform = `translateY(-${gridTransform}px) scale3d(${gridScaler[0]}, ${gridScaler[1]}, 1)`;
                                bcWrapperRef.current.style.transition = `transform ${projExitBgDuration}s cubic-bezier(${projExitBgEase[0]}, ${projExitBgEase[1]}, ${projExitBgEase[2]}, ${projExitBgEase[3]})`;
                                bcWrapperRef.current.style.transform = `translateY(-${gridTransform}px) scale3d(${gridScaler[0]}, ${gridScaler[1]}, 1)`;
                            }


                            
                            if(bgGradRef.current) bgGradRef.current.style.opacity = 0;
                            if(tlRef.current) tlRef.current.style.transformOrigin = 'top left'; tlRef.current.style.transform = `translate3d(0px, 0px, 0) scale3d(${1/gridScaler[0]}, ${1/gridScaler[1]}, 1)`; tlRef.current.style.transition = `transform ${projExitBgDuration}s cubic-bezier(${projExitBgEase[0]}, ${projExitBgEase[1]}, ${projExitBgEase[2]}, ${projExitBgEase[3]})`;
                            if(trRef.current) trRef.current.style.transformOrigin = 'top right'; trRef.current.style.transform = `translate3d(0px, 0px, 0) scale3d(${1/gridScaler[0]}, ${1/gridScaler[1]}, 1)`; trRef.current.style.transition = `transform ${projExitBgDuration}s cubic-bezier(${projExitBgEase[0]}, ${projExitBgEase[1]}, ${projExitBgEase[2]}, ${projExitBgEase[3]})`;
                            if(blRef.current) blRef.current.style.transformOrigin = 'bottom left'; blRef.current.style.transform = `translate3d(0px, 0px, 0) scale3d(${1/gridScaler[0]}, ${1/gridScaler[1]}, 1)`; blRef.current.style.transition = `transform ${projExitBgDuration}s cubic-bezier(${projExitBgEase[0]}, ${projExitBgEase[1]}, ${projExitBgEase[2]}, ${projExitBgEase[3]})`;
                            if(brRef.current) brRef.current.style.transformOrigin = 'bottom right'; brRef.current.style.transform = `translate3d(0px, 0px, 0) scale3d(${1/gridScaler[0]}, ${1/gridScaler[1]}, 1)`; brRef.current.style.transition = `transform ${projExitBgDuration}s cubic-bezier(${projExitBgEase[0]}, ${projExitBgEase[1]}, ${projExitBgEase[2]}, ${projExitBgEase[3]})`;
                            

                            let maxWidth = window.innerWidth;
                            let maxHeight = window.innerHeight;
                            let targetMargin = 80;
                            targetWidth = maxWidth - getGutterWidth(window.innerWidth).main;
                            let targetHeight = Math.min(targetWidth * (9/16), window.innerHeight - 180);

                            let offsetdelta = 30;
                            topCurveRef.current.style.transition = `transform ${projExitBgDuration}s cubic-bezier(${projExitBgEase[0]}, ${projExitBgEase[1]}, ${projExitBgEase[2]}, ${projExitBgEase[3]})`;
                            bottomCurveRef.current.style.transition = `transform ${projExitBgDuration}s cubic-bezier(${projExitBgEase[0]}, ${projExitBgEase[1]}, ${projExitBgEase[2]}, ${projExitBgEase[3]})`;
                            leftCurveRef.current.style.transition = `transform ${projExitBgDuration}s cubic-bezier(${projExitBgEase[0]}, ${projExitBgEase[1]}, ${projExitBgEase[2]}, ${projExitBgEase[3]})`;
                            rightCurveRef.current.style.transition = `transform ${projExitBgDuration}s cubic-bezier(${projExitBgEase[0]}, ${projExitBgEase[1]}, ${projExitBgEase[2]}, ${projExitBgEase[3]})`;

                            if(topCurveRef.current){
                                let deltaX = targetWidth - topCurveRef.current.offsetWidth;
                                let transformValue = topCurveRef.current.getBoundingClientRect().top + topCurveRef.current.offsetHeight + offsetdelta - 40;
                                scaleBy(topCurveRef, deltaX, 'X', `translate3d(0px,-${transformValue}px,0)`);
                                scaleBy(bottomCurveRef, deltaX, 'X', `translate3d(0px,${transformValue}px,0)`);
                            } if (leftCurveRef.current){
                                let deltaY = targetHeight - leftCurveRef.current.offsetHeight;
                                let transformValue = leftCurveRef.current.getBoundingClientRect().left + topCurveRef.current.offsetHeight + offsetdelta - 40 ;
                                scaleBy(leftCurveRef, deltaY, 'Y', `translate3d(-${transformValue}px, -${curveTransformDelta}px,0)`);
                                scaleBy(rightCurveRef, deltaY, 'Y', `translate3d(${transformValue}px, -${curveTransformDelta}px,0)`);
                            }
                        }, projExitBgDelay*1000)
                    }
                }else{
                    if(!isMobile){
                        archiveListWrapperRef.current.style.pointerEvents = "none";
                        let count = 0;
                        let centerInterval = setInterval(() => {
                            count ++;
                            if(count == 10) clearInterval(centerInterval);
                            mouseX.set(window.innerWidth/2);
                            mouseY.set(window.innerHeight/2);
                            setMousePosition({left: window.innerWidth/2,top: window.innerHeight/2});
                        }, 20)
                    }
                }
                if (!isMobile){
                    if(isProjectExit){
                        setTimeout(() => {
                            safeToRemove()
                        }, (projExitBgDelay + projExitBgDuration) * 1000)
                    } else{
                        let targUrl = window.location.href;
                        let targStub = targUrl.split("/").slice(-1)
                        
                        if(targStub==""){
                            setIsHomeExit(true);
                            let boundingInfo = visBackgroundRef.current.getBoundingClientRect();
                            let transformInfo = visBackgroundRef.current.transform;
                            let xScale = boundingInfo.width / visBackgroundRef.current.offsetWidth;
                            let yScale = boundingInfo.height / visBackgroundRef.current.offsetHeight;

                            let curHeight = boundingInfo.height;
                            let curWidth = boundingInfo.width;
                            let heightScaler = yScale * exitTargetHeight/curHeight;
                            let widthScaler = xScale * exitTargetWidth/curWidth;
                            setActiveIdx(0)
                            setTriggerArchiveToHomepageTransition(true);
                            let targWrapper = transWiperRef.current;
                            let targetWiper = targWrapper.getElementsByClassName("transition_wiper")[0];
                            targetWiper.classList.add("right_to_left");
                            targetWiper.style.animationDelay = "0.5s";
                            setTimeout(() => {
                                //perform animation into homepage
                                
                                // setTriggerArchiveToHomepageTransition(true);

                                visBackgroundRef.current.style.transformOrigin = "center"
                                visBackgroundRef.current.style.transform = `translate(-50%, -50%) scale(${widthScaler}, ${heightScaler})`;
                                bgScalerRef.current.style.transform = `scale(1, 2)`
                                visBackgroundRef.current.style.transition = `transform 1s cubic-bezier(0.16, 1, 0.3, 1), opacity 1s 0.5s cubic-bezier(0.16, 1, 0.3, 1)`;
                            }, 500)
                            navigate('/', {state:{isFromArchive:true}})
                            setTimeout(() => {
                                safeToRemove()
                            }, 1500)
                        } else{
                            backgroundWrapperRef.current.style.opacity = 0;
                            setTimeout(() => {
                                safeToRemove()
                            }, 1000)
                        }
                    }
                } else{
                    safeToRemove()
                }
            }
        } catch{
            console.warn("error occured in archive calculations")
        }

        
    }, [isPresent])

    function handleOrientation(event){
        try{
        let alpha = event.alpha;
        let beta = event.beta;
        let gamma = event.gamma;

        let vertRange = [0, 180]
        let horizRange = [0, 360]

        // beta range is from -180 (facing floor) to 180 facing ceiling
        // alpha from 0 to 359 twisting left to right and away
        
        if(beta < vertRange[0]){

        } else if (beta > vertRange[1]){

        } else{
            let vertProgress = Math.abs(beta) / vertRange[1];
            let adjustedProg = vertProgress - 0.5;
            let deltaY = window.innerHeight * adjustedProg
            let YSim = (window.innerHeight/2) - deltaY;
            mouseY.set(YSim);
        }
    } catch{}

    }

    useEffect(() => {
        // set HomeToArchiveTransitionTrigger to false
        // Means that if we have come from the homepage, we are deactivating the overlay which is rendered for the transition between these two stages
        // thereby triggering the exit of it as our archive mounts
        setHomeToArchiveTransitionTrigger(false);
        if(deviceType == "touchOnly"){
            setIsScreen(true);
        }
        // Adds a listener for orientation change - touch devices (tablet) listen to these changes and move the background
        // around accordingly - similar to how mouse causes the movement 
        if(primaryInput == "touch")window.addEventListener("deviceorientation", handleOrientation);

        try{
            let boundingInfo = visBackgroundRef.current.getBoundingClientRect();
            let curHeight = boundingInfo.height;
            let curWidth = boundingInfo.width;
            let targHeight;
            let targWidth;

            // Precompute the exit target heights/scaler values needed to animate the
            // background element by on page exit
            if(primaryInput == "mouse"){
                targHeight = (window.innerHeight/5) - 20;
                targWidth = (window.innerHeight/5)  * 2.25;
            }else{
                targHeight = (window.innerHeight/4) - 20;
                targWidth = ((window.innerHeight/4) - 20) * (4/3) * (1.25);
            }
            setExitTargetHeight(targHeight);
            setExitTargetWidth(targWidth);
            let heightScaler = targHeight/curHeight;
            let widthScaler = targWidth/curWidth;
            setHomeExitScaler(widthScaler/heightScaler);
        }catch{}

        responsiveResize();
        window.addEventListener('resize', responsiveResize, false);
        setTimeout(() => {
            setIsFirstLoad(false);
        }, 50)

        setCursorText("")

        setTimeout(() => {
            if(archiveListWrapperRef.current){try{archiveListWrapperRef.current.style.pointerEvents="all"}catch{}}
            if(primaryInput == "touch"){setBgCornersActive(true)}
        }, 500)

        return() => {
            window.removeEventListener('resize', responsiveResize);
            window.removeEventListener("deviceorientation", handleOrientation);
        }
    }, [])


    const debounceActiveStateTwo = useCallback(
        debounce(() => {
            setBgCornersActive(true);
          }, 50),
          []
    );

    const debouncedActiveState = useCallback(
        debounce(() => {
          setBgCornersActive(true);
        }, 500),
        []
      );

    const debouncedHover = useCallback(
        debounce((index) => {
          setActiveIdx(index);
        }, 300)
    ,[]);
    
    // Handle mouse leave by canceling the debounced function
    const handleMouseLeave = () => {
        if(isPresent){
            debouncedHover.cancel();
            debouncedActiveState.cancel();
            debounceActiveStateTwo.cancel();
            setBgCornersActive(false);
        } else setBgCornersActive(true);
    };

    const handleMobOverlayExitClick = () => {
        if(isMobile){
            mobScrollRef.current.style.overflowY="scroll"
        }else scroller.start();
        mobileElementRefs.current[activeIdx].classList.remove('selected_mob_li')
        for(let i = 0; i<mobileElementRefs.current.length; i++){
            let curTarg = mobileElementRefs.current[i];
            curTarg.classList.remove('dimmer')
        }

        videoRef.current.style.opacity = 0;
        vidBorderRef.current.style.opacity = 0;

        upperFilterBannerRef.current.style.filter = "blur(0px)"
        upperFilterBannerRef.current.style.opacity = "1"

        setMobOverlayMode(false);
        if(upperFilterBannerRef.current)upperFilterBannerRef.current.style.transform = `translate3d(0, 0px, 0)`
        if(listWrapperRef.current)listWrapperRef.current.style.transform = `translate3d(0, 0px, 0)`
    }

    const handleMobLiClick = (idx) => {
        // Stop the scrolling if clicked when moving
        if(isMobile){
            mobScrollRef.current.style.overflow="hidden"
        } else{
            scroller.scrollTo(scroller.scroll.instance.scroll.y, { duration: 0.25 });
            scroller.stop();
        }
        if(!mobOverlayMode){
            //handle old active
            mobileElementRefs.current[activeIdx].classList.remove('selected_mob_li');

            // handle new active
            mobileElementRefs.current[idx].classList.add('selected_mob_li');

            upperFilterBannerRef.current.style.filter = "blur(2px)"
            upperFilterBannerRef.current.style.opacity = "0.5"

            for(let i = 0; i<mobileElementRefs.current.length; i++){
                try{if (i !== idx) mobileElementRefs.current[i].classList.add('dimmer')}
                catch{}
            }

            if(mobBgControlRef.current){
                let bgTilePos = mobBgControlRef.current.getBoundingClientRect();
                let liPos = mobileElementRefs.current[idx].getBoundingClientRect();

                let bgCalculatedHeight = (1/filteredData[idx].aspectRatio) * (window.innerWidth - 40);
                let windowTop = (window.innerHeight/2) - (bgCalculatedHeight/2) - 10;
                let windowBottom = (window.innerHeight/2) + (bgCalculatedHeight/2) + 40;


                if(liPos.bottom > windowTop && liPos.bottom < windowBottom || liPos.top > windowTop && liPos.top < windowBottom){
                    let topDelta =  windowTop - liPos.bottom;
                    let bottomDelta = windowBottom - liPos.top;
                    let deltaY;
                    if(Math.abs(topDelta) < bottomDelta+35) deltaY = topDelta;
                    else deltaY = bottomDelta;
                    upperFilterBannerRef.current.style.transform = `translate3d(0, ${deltaY}px, 0)`
                    listWrapperRef.current.style.transform = `translate3d(0, ${deltaY}px, 0)`
                }
                
            }

            setActiveIdx(idx);
            setMobOverlayMode(true);
        }else if(idx !== activeIdx && mobOverlayMode){
            handleMobOverlayExitClick();
            
        }
    }

    // On click scroll back to top
    const toTopClick = () => {
        if(isMobile){
            smoothScrollTo(
                mobScrollRef.current,
                0,
                0,
                1250,
                [0.16, 1, 0.3, 1]
            )
        }else{
            scroller.scrollTo('top', {
                'offset': 0,
                'duration': 750,
                'easing': [0.16, 1, 0.3, 1]
            })
        }
    }

    // Set up locomotive scroll
    useEffect(() => {
        if(scrollRef.current && isMobile !== null && !isMobile){
            let tmpScroll = new LocomotiveScroll({
                el: scrollRef.current,
                smooth: true,
                lerp: 0.025,
                reloadOnContextChange: true,
                multiplier: 1.2,
                touchMultiplier: 3,
                direction: 'vertical',
                smartphone: {
                    smooth: true,
                    direction: 'vertical'
                },
                tablet: {
                    smooth: true,
                    direction: 'vertical',
        
                },
            });
            setScroller(tmpScroll);
        }
    }, [scrollRef.current, isMobile])

    const scaleBy = (useThisRef, additionalPixel, mode='A', additionalTransform="")=> {
        /**
         * useThisRef - ref to be used
         * additionalPixel - pixel delta the target should be scaled up by
         * mode - axes of operation: A = all (both), Y = y axis, X = x axis
         * additionalTransform - any additional transform to be applied when scaling
         */
        if(useThisRef.current){
            let width = useThisRef.current.offsetWidth;
            let height = useThisRef.current.offsetHeight;

            let wRatio = 1 + (additionalPixel/width);
            let hRatio = 1 + (additionalPixel/height);

            if(mode=='A')useThisRef.current.style.transform = `scale3d(${wRatio}, ${hRatio}, 1) ` + additionalTransform;
            else if(mode=="Y") useThisRef.current.style.transform = "scale3d(1,"+hRatio+', 1) ' + additionalTransform;
            else useThisRef.current.style.transform = "scale3d("+wRatio+',1, 1) ' + additionalTransform;
        }
    }

    //Used to calculate where the intersection points are between the grid liens when they bend
    function findIntersections() {
        let topLeftCoords = tlRef.current.getBoundingClientRect();

        let leftPeakX = topLeftCoords.left-25;
        let leftPeakY = window.innerHeight/2;

        let upperPeakX = window.innerWidth/2;
        let upperPeakY = topLeftCoords.top-25;

        let a = 100/(window.innerWidth*window.innerWidth);
        let h = upperPeakX;
        let k = upperPeakY;

        let left_a = 100/(window.innerHeight*window.innerHeight);
        let left_h = leftPeakY;
        let left_k = leftPeakX;

        let distance = null;
        let bestCoords = null;

        // This makes use of a formula for calculating the height of an object following a parabolic path
        // The clippath bending is essentially just a parabola, so by applying this and solving for both we can find
        // the intersection point between the grid lines
        for (let i = upperPeakY; i <= topLeftCoords.top; i++){
            let x_pos = left_a * Math.pow(i - left_h, 2) + left_k;

            let y = a * Math.pow(x_pos - h, 2) + k;
            
            let tempDist = Math.abs(Math.pow(i-y, 2));
            if(distance)
                if (tempDist <= distance)
                    distance = tempDist
                else
                    break
            else
                distance = tempDist; bestCoords = [x_pos, (y+i)/2]
        }

        //Now we have the delta, we know hoq much we need to translate the corner elements by in order to 
        // move them to the same position the new intersection points are lying at
        let tlTopDelta = topLeftCoords.top - bestCoords[1];
        let tlLeftDelta = topLeftCoords.left - bestCoords[0];
        tlRef.current.style.transform = "translate(-"+tlLeftDelta+"px,-"+tlTopDelta+"px)";
        trRef.current.style.transform = "translate("+tlLeftDelta+"px,-"+tlTopDelta+"px)";
        blRef.current.style.transform = "translate(-"+tlLeftDelta+"px,"+tlTopDelta+"px)";
        brRef.current.style.transform = "translate("+tlLeftDelta+"px,"+tlTopDelta+"px)";


    }

    // On load make visible
    const handleVideoLoad = () => {
        if(videoRef.current){
            videoRef.current.style.opacity = 1;
            vidBorderRef.current.style.opacity = 1;
        }
    }

    // Handle bgCornersActive (backgroundCornersActive) change
    // Changes when touchscreen user selects new entry or mouse user hovers over an entry
    useEffect(() => {
        // If bg corners active and background is present & rendered etc:
        if(glRef.current && bgCornersActive && visBackgroundRef.current && isPresent){
            let gridAmt = 15;
            let crnrAmt = gridAmt/2;

            // Get intersections of the grid lines and move the corner elements to amtch
            findIntersections()

            scaleBy(visBackgroundRef, 40, 'A', "translate3d(-50%,-50%,0)");

            // Move the curves which are masking the background video, increase scale and move them towards the outside to give a 'warp' effect
            scaleBy(topCurveRef, 45, 'X', "translate3d(0,-25px,0)");
            scaleBy(bottomCurveRef, 45, 'X', "translate3d(0,25px,0)");
            scaleBy(rightCurveRef, 40, 'Y', 'translate3d(25px, 0, 0)');
            scaleBy(leftCurveRef, 40, 'Y', 'translate3d(-25px, 0, 0)');
        }
        else if(glRef.current && !bgCornersActive && visBackgroundRef.current && isPresent){
            // No longer active so go back to resting state
            glRef.current.style.transform = "scale("+1+','+1+')';
            visBackgroundRef.current.style.transform = "translate3d(-50%,-50%,0) scale("+1+','+1+')';

            // reset the curves back to their start (flatter, less pronounced curve)
            scaleBy(topCurveRef, 10, 'X', "translate3d(0,0px,0)");
            scaleBy(bottomCurveRef, 10, 'X', "translate3d(0,0px,0)");
            scaleBy(rightCurveRef, 10, 'Y', 'translate3d(0px, 0, 0)');
            scaleBy(leftCurveRef, 10, 'Y', 'translate3d(0px, 0, 0)');

            // Move the corner elements back to their starting position
            tlRef.current.style.transform = "translate3d(0px, 0px, 0)";
            trRef.current.style.transform = "translate3d(0px, 0px, 0)";
            blRef.current.style.transform = "translate3d(0px, 0px, 0)";
            brRef.current.style.transform = "translate3d(0px, 0px, 0)";
        }
       
    }, [bgCornersActive])

    useEffect(() => {
        if(!isMobile){
            let targ = archiveElementRefs.current;
            targ[activeIdx].classList.add('p_selected');
            for(let i=0; i<targ.length; i++){
                if(i !== activeIdx){
                    try{
                        targ[i].classList.remove('p_selected')
                    }catch{}
                }
            }
        }
    }, [activeIdx])

    // When location changes, if it contains projects then we set the flag to indicate its a project exit
    // Need to do this as we have different exit animations for project and non-project transitions
    useEffect(() => {
        let newLoc = window.location.href;
        if(location && newLoc.includes("projects")){
            setIsProjectExit(true)
        }else{
            setIsProjectExit(false)
        }
    }, [location])

    const performRedirect = (selected) => {
         // If the element is active, then we know the mouse user has clicked or tablet user has clicked on the active index and therefore should redirect

        // Set colour mode to true to remove grayscale/invert if its active
        setIsColourMode(true);
        let count = 0;

        // Need a small timeout for mouseX, mouseY to work correctly
        // The backgorund elements positioning is dependent onthe mouseX/mouseY
        // settings this to the middle causes the background element to return to the center of the screen
        // (means when we then scale it up it will scale from the center and match exactly with the project thumbnail on transition)
        let centerInterval = setInterval(() => {
            count ++;
            if(count == 10) clearInterval(centerInterval);
            mouseX.set(window.innerWidth/2);
            mouseY.set(window.innerHeight/2);
            setMousePosition({left: window.innerWidth/2,top: window.innerHeight/2});
        }, 20)

        // set is project exit and navigate, adding state that we have come from archive to let the 
        // project page know so we can handle any custom logic we need to if we have naviagted to it from archive opposed to home or contact for example
        let path = filteredData[selected].title;
        setIsProjectExit(true);
        navigate('/projects/'+path, {state:{isFromArchive:true}})
    }

    // This is actually called every time a user clicks on an element, this handles the mobile, desktop and touchscreen functionality
    const handleProjectRedirect = (selected) =>{
        // Simply sets variables and styling of elements necessary for page transition

        if(primaryInput == "touch"){
            if(isMobile){
                setIsColourMode(true);
                vidBorderRef.current.style.transition = "opacity 1s ease, color 1s ease";
                vidBorderRef.current.style.opacity = 0;
                let path = filteredData[selected].title;
                setIsProjectExit(true);
                videoRef.current.style.border = "3px solid var(--dark-color)";
                navigate('/projects/'+path, {state:{isFromArchive:true}})

            }else{
                // If the selected index (clicked item) is not active then we set active index. This is impossible on desktop as mouseenter sets active index
                // automatically, so this is here for touchscreen devices, when they click and it an entry that isnt already selected, we just want to change the active index
                // essentially immitating the hover effect for desktop, on tablet
                if(selected !== activeIdx)setActiveIdx(selected);
                else performRedirect(selected)
            }
        } else{
            performRedirect(selected)
        }
    }

    return(
        <>
            {
                isMobile ? 
                    <motion.div
                        className="mob_archv_page_wrapper"
                        initial="initial"
                        animate="animate"
                        exit="exit"
                    >
                        <div 
                            className="mob_archv_list_wrapper"
                            ref={mobScrollRef}    
                        >
                            {filteredData &&
                                <motion.div
                                    className="mob_archv_main_content"
                                    variants={mobItemsWrapperVariants}
                                    data-scroll-id="mob-archv-scroller"
                                    data-scroll-container
                                    ref={scrollRef}
                                >
                                    <div 
                                        className="mob_list_items_container"
                                        data-scroll-section
                                        id="mob-archv-scroller"
                                    >
                                        <div 
                                            className="upper_filter_banner_wrapper padding_1"
                                            ref={upperFilterBannerRef}    
                                        >
                                            <div className="upper_banner_title_wrapper">
                                                <motion.div
                                                    initial="initial"
                                                    animate="animate"
                                                    exit="exit"
                                                    variants={mobFilterUpperWrapperVariants}
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: "row"
                                                    }}
                                                >
                                                    <motion.span
                                                        className="mob_upper_title"
                                                        variants={mobBannerTitleVariants}
                                                        custom={0}
                                                    >
                                                        PROJECTS
                                                    </motion.span>
                                                    <div className="archv_proj_num_wrapper">
                                                        <span
                                                            style={{
                                                                display: "flex",
                                                                overflow: "hidden"
                                                            }}
                                                        >
                                                            <motion.span 
                                                                className="title_proj_num"
                                                                variants={mobBannerTitleVariants}
                                                                custom={0.25}
                                                            >[{filteredData.length}]</motion.span>
                                                        </span>
                                                    </div>
                                                </motion.div>
                                            </div>
                                            <div className="mob_filter_items_wrapper">
                                                <MobArchiveFilters 
                                                    activeFilter={activeFilter}
                                                    setActiveFilter={setActiveFilter}
                                                    projData={projData}
                                                />
                                            </div>
                                            <div className="mob_col_mode archv-colour">
                                                {/* <NewColourMode 
                                                    isColourMode={isColourMode} setIsColourMode={setIsColourMode} initialDelay={0.5}/> */}
                                            </div>
                                            <motion.div
                                                className="blurrer"
                                                initial="initial"
                                                animate={filteredData && mobOverlayMode ? "animate" : "initial"}
                                                onClick={handleMobOverlayExitClick}
                                            ></motion.div>
                                        </div>
                                        <div 
                                            className="mob_archv_list__wrapper"
                                            ref={listWrapperRef}
                                        >
                                            {
                                                filteredData.map((item, idx) => (
                                                        <MobArchiveListItem 
                                                            item={item}
                                                            activeIdx={activeIdx}
                                                            idx={idx} 
                                                            handleMobLiClick={handleMobLiClick}
                                                            mobileElementRefs={mobileElementRefs}
                                                            isColourMode={isColourMode}
                                                            isInFilter={((item.tags.includes(activeFilter)) || (activeFilter == 0))}
                                                            // archiveElementRefs={archiveElementRefs}
                                                        />
                                                ))
                                            }
                                            <motion.div
                                                className="blurrer"
                                                initial="initial"
                                                animate={filteredData && mobOverlayMode ? "animate" : "initial"}
                                                exit="exit"
                                                onClick={handleMobOverlayExitClick}
                                            ></motion.div>
                                        </div>
                                        <div 
                                            className="mob-archv-to-top"
                                            onClick={() => toTopClick()}
                                            ref={toTopRef}
                                        >
                                            <span>TO THE TOP</span>
                                        </div>
                                    </div>
                                </motion.div>
                            }
                            <motion.div
                                className={`mob_active_background_ele_wrapper`}
                                initial="initial"
                                animate={filteredData && mobOverlayMode ? "animate" : "initial"}
                                exit={isProjectExit ? "projectExit" : "exit"}
                                ref={mobBackgroundWrapperRef}
                                variants={bgOverlayWrapperVariants}
                            >
                                <motion.div 
                                    className="mob_background_ele"
                                    ref={bgEleRef}
                                    style={{
                                        pointerEvents: mobOverlayMode ? "all" : "none"
                                    }}
                                    variants={mobBgVariants}
                                >
                                    <motion.video
                                        preload="auto"
                                        muted autoPlay loop playsInline
                                        key={"mob vid - " + activeIdx}
                                        style={{
                                            position: "relative",
                                            display: "block",
                                            top: "-3px",
                                            left: "-3px",
                                            width: "calc(100% + 6px)",
                                            objectFit: "cover",
                                            zIndex: 3,
                                            opacity: 0,
                                            objectPosition: "center",
                                            border: "3px solid var(--light-color)",
                                            aspectRatio: filteredData[activeIdx].aspectRatio,
                                            transition: "opacity 1s ease, border 1s ease",
                                        }}
                                        onPlay={() => {handleVideoLoad()}}
                                        ref={videoRef}
                                        variants={videoVariants}
                                        poster={filteredData[activeIdx].thumbnails.mobile}
                                    >
                                        <source src={filteredData[activeIdx].gifStyling.backgroundImage} type="video/mp4"  media="(min-width: 601px)"/>
                                        <source src={filteredData[activeIdx].gifStyling.mobileVideo} type="video/mp4"  media="(max-width: 600px)"/>
                                    </motion.video>
                                        <div className={` ${!isColourMode ? 'inv-mde' : ''}`} ref={vidBorderRef}/>
                                    <motion.div 
                                        className="mob_bg_controls"
                                        ref={mobBgControlRef}
                                        variants={mobControlVariants}
                                    >
                                        <motion.span 
                                            className="view_proj"
                                            onClick={() => handleProjectRedirect(activeIdx)}
                                        >
                                            VIEW PROJECT
                                        </motion.span>
                                        <motion.span
                                            className={`toggle_mob_over ${!isColourMode ? 'inv-mde' : ''}`}
                                            onClick={handleMobOverlayExitClick}
                                        >
                                            CLOSE
                                        </motion.span>
                                    </motion.div>
                                    <div 
                                        className="np_transition__wrapper"
                                    >
                                        <ProgressiveBackgroundImg
                                            placeholderSrc={filteredData[activeIdx].thumbnails.placeholder }
                                            src={filteredData[activeIdx].thumbnails.mobile}
                                            idx={activeIdx}
                                            forceFullWidth={true}
                                            animateIn={false}
                                            startFullRes={true}
                                            addClassNames={`transition_wiper ${isProjectExit ? 'right_to_left' : ''}`}
                                        />  
                                    </div>
                                </motion.div>
                            </motion.div>
                        </div>
                    </motion.div>
                :
                    <>
                        <motion.div
                            className="archive_page_wrapper" 
                            initial="initial"
                            animate="animate"
                            exit="exit"
                            onMouseMove={!isScreen ? handleMouseMove : null}
                        >
                            <div className="archive_content_wrapper">
                                <motion.div
                                    className="archive_list_wrapper"
                                    style={{
                                        fontWeight: primaryInput == "touch" ? "700" : null
                                    }}
                                    custom={isFirstLoad}
                                    ref={archiveListWrapperRef}
                                >
                                    <AnimatePresence mode="wait">
                                        {projData && projData.map((item, idx) => (
                                            <ArchiveListItem 
                                                item={item}
                                                activeIdx={activeIdx}
                                                idx={idx} 
                                                activeFilter={activeFilter}
                                                setActiveIdx={setActiveIdx}
                                                archiveElementRefs={archiveElementRefs}
                                                onMouseEnter={() => {
                                                    if(isPresent){
                                                        if(idx === activeIdx) debounceActiveStateTwo();
                                                        else{
                                                            debouncedHover(idx);
                                                            debouncedActiveState.cancel();
                                                            debouncedActiveState();
                                                        }
                                                    } else{
                                                        setBgCornersActive(true);
                                                    }
                                                }}
                                                onMouseLeave={handleMouseLeave}
                                                handleEleClicked={handleProjectRedirect}
                                                isProjectExit={isProjectExit}
                                                isFiltered={activeFilter !== 0 && !item.tags.includes(activeFilter)}
                                                isPresent={isPresent}
                                            />
                                        ))}
                                    </AnimatePresence>
                                </motion.div>
                            </div>
                            <motion.div 
                                className="archive_background_element_wrapper"
                                initial="initial"
                                animate="animate"
                                exit={location.pathname.includes("project") ? "projExit" : "standardExit"}
                                // variants={backgroundWrapperVariants}
                                ref={backgroundWrapperRef}
                            >    
                                <motion.div
                                    className="sw"
                                    ref={visBackgroundRef}
                                >
                                    <motion.div
                                        className="archv_background_ele"
                                        style={{
                                            // opacity: idx == activeIdx ? 1 : 0,
                                            x: parallaxX,
                                            y: parallaxY,
                                            rotateX: rotateX,
                                            rotateY: rotateY_2,
                                            zIndex: 5
                                        }}
                                        ref={mainBgRef}
                                        initial="initial"
                                        animate="animate"
                                        exit="exit"                                                    
                                    >
                                        <motion.div 
                                            className="bg_wrapper_scaler"
                                            initial={{
                                                transform: isFirstLoad ? "transform(0, 100%, 0)" : "scale(1)"
                                            }}
                                            animate={{
                                                transform: "scale(1)",
                                                transition: {
                                                    duration: 2,
                                                    delay: 1,
                                                    ease: [0.16, 1, 0.3, 1]
                                                }
                                            }}
                                            exit={ isProjectExit ? {
                                                transform: `scale3d(1, ${visBgScaler[0]/visBgScaler[1]}, 1)`,
                                                transition: {
                                                    duration: projExitBgDuration,
                                                    delay: projExitBgDelay,
                                                    ease: [projExitBgEase[0], projExitBgEase[1], projExitBgEase[2], projExitBgEase[3]]
                                                }
                                            } : isHomeExit ? {
                                                transform:  `scale3d(1, ${homeExitScaler}, 1)` ,
                                                transition: {
                                                    duration: projExitBgDuration,
                                                    delay: 0,
                                                    ease: [projExitBgEase[0], projExitBgEase[1], projExitBgEase[2], projExitBgEase[3]]
                                                }
                                            } : {}}
                                            ref={bgScalerRef}
                                        >
                                            <AnimatePresence mode="sync">
                                            {
                                                projData && projData.map((item, idx) => (
                                                    idx == activeIdx &&
                                                    <motion.video
                                                        muted
                                                        autoPlay
                                                        loop
                                                        playsInline
                                                        key={"elebggif-"+idx+item.title+"-"+activeIdx}
                                                        className="ele_background_gif"
                                                        initial={isColourMode ? "initialColour" : "initialGrey"}
                                                        animate={isColourMode ? "colour" : "grey"}
                                                        exit={isColourMode ? "exitColour" : "exitGrey"}
                                                        custom={isFirstLoad}
                                                        variants={bgVariants}
                                                        ref={directBGRef}
                                                        style={{
                                                            // backgroundImage: p_idx == activeMetaInfo ? 'url('.concat(projItem.gifStyling.backgroundImage, ')') : 'url('.concat(projItem.gifStyling.backgroundImage, ')'),
                                                            height: "100%",
                                                            width: "100%",
                                                            objectFit: "cover"
                                                        }}
                                                    >
                                                        <source src={item.gifStyling.backgroundImage} type="video/mp4"  media="(min-width: 601px)"/>
                                                        <source src={item.gifStyling.mobileVideo} type="video/mp4"  media="(max-width: 600px)"/>
                                                    </motion.video>
                                                ))
                                            }
                                            </AnimatePresence>
                                            <div className="np_transition__wrapper" ref={transWiperRef}>
                                                <ProgressiveBackgroundImg
                                                    placeholderSrc={projData[activeIdx].thumbnails.placeholder }
                                                    src={projData[activeIdx].thumbnails.desktop}
                                                    idx={activeIdx}
                                                    forceFullWidth={true}
                                                    animateIn={false}
                                                    startFullRes={true}
                                                    addClassNames={`transition_wiper ${isProjectExit ? 'right_to_left' : null}`}
                                                />  
                                            </div>
                                            
                                        </motion.div>
                                    </motion.div>
                                </motion.div>
                                <AnimatePresence >                          
                                    <motion.div
                                        className={`archv_background_ele invis-bg ${bgCornersActive ? 'active-c' : ''}`}
                                        initial="initial"
                                        animate="animate"
                                        exit="exit"
                                        style={{
                                            opacity: 1,
                                            x: parallaxX,
                                            y: parallaxY,
                                            rotateX: rotateX,
                                            rotateY: rotateY_2,
                                        }}
                                        ref={secondaryBgRef}
                                    >
                                        
                                        <div
                                            className="upper-curve-wrapper curve-wrapper"
                                            style={{
                                                position: "absolute",
                                                left: 0,
                                                top: "-100px",
                                                width: "100%"
                                            }}
                                            ref={topCurveRef}
                                        >
                                            <svg 
                                                width="auto"
                                                height="130"
                                                viewBox="0 0 531 130"
                                                preserveAspectRatio="none"
                                            >
                                                <motion.path
                                                    initial="deep"
                                                    animate={bgCornersActive ? "deep" : "shallow"}
                                                    exit="shallow"
                                                    variants={svgTestVariants}
                                                    style={{width: "100%"}}
                                                    fill="var(--dark-color)"
                                                />
                                            </svg>
                                        </div>
                                        <div
                                            className="right-curve-wrapper curve-wrapper"
                                            style={{
                                                position: "absolute",
                                                right: "-100px",
                                                top: 0,
                                                height: "100%"
                                            }}
                                            ref={rightCurveRef}
                                        >
                                        <svg 
                                            width="130"
                                            height="auto"
                                            viewBox="0 0 130 532"
                                            preserveAspectRatio="none"
                                        >
                                            <motion.path
                                                initial="shallow"
                                                animate={bgCornersActive ? "deep" : "shallow"}
                                                exit="shallow"
                                                variants={sideCurveVariantd}
                                                style={{height: "100%"}}
                                                fill="var(--dark-color)"
                                            />
                                        </svg>
                                        </div>
                                        <div
                                            className="left-curve-wrapper curve-wrapper"
                                            style={{
                                                position: "absolute",
                                                left: "-100px",
                                                top: 0,
                                                height: "100%",
                                            }}
                                            ref={leftCurveRef}
                                        >
                                        <svg 
                                            width="130"
                                            height="auto"
                                            viewBox="0 0 130 532"
                                            preserveAspectRatio="none"
                                            style={{
                                                transform: "rotate(180deg)"
                                            }}
                                        >
                                            <motion.path
                                                initial="shallow"
                                                animate={bgCornersActive ? "deep" : "shallow"}
                                                exit="shallow"
                                                variants={sideCurveVariantd}
                                                style={{height: "100%"}}
                                                fill="var(--dark-color)"
                                            />
                                        </svg>
                                        </div>
                                        <div
                                            className="lower-curve-wrapper curve-wrapper"
                                            style={{
                                                position: "absolute",
                                                left: 0,
                                                bottom: "-100px",
                                                width: "100%"
                                            }}
                                            ref={bottomCurveRef}
                                        >
                                        <svg 
                                            width="auto"
                                            height="130"
                                            viewBox="0 0 531 130"
                                            preserveAspectRatio="none"
                                            style={{transform: "rotate(180deg)"}}
                                        >
                                            <motion.path
                                                initial="shallow"
                                                animate={bgCornersActive ? "deep" : "shallow"}
                                                exit="shallow"
                                                variants={svgTestVariants}
                                                style={{width: "100%"}}
                                                fill="var(--dark-color)"
                                            />
                                        </svg>
                                        </div>
                                        <CornerComponent 
                                            size={40}
                                            wrappingRoom={40}
                                            displayIndex={4}
                                            bcWrapperRef={bcWrapperRef}
                                            tlRef={tlRef}
                                            trRef={trRef}
                                            blRef={blRef}
                                            brRef={brRef}
                                            isPresent={isPresent}
                                            bgCornersActive={bgCornersActive}
                                            isProjectExit={isProjectExit}
                                            performInitial={true}
                                            triggerExit={!isPresent && !isProjectExit}
                                        />
                                        <div
                                            className={`a_gl_wrapper`}
                                            ref={glRef}
                                            style={{
                                                zIndex: 2
                                            }}
                                        >
                                            <div className="grid-line-wrapper left-line"
                                                style={{
                                                    position: "fixed",
                                                    display: "flex",
                                                    height: "110vh",
                                                    bottom: "50%",
                                                }}
                                                ref={leftLineRef}  
                                            >
                                                <motion.svg 
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="30" 
                                                    height="100%" 
                                                    viewBox="0 0 30 700" fill="none"
                                                    style={{
                                                        height: "100%",
                                                        transformOrigin: "bottom"
                                                    }}
                                                    initial="initial"
                                                    animate={!isPresent && !isProjectExit ? "defaultExit" : "animate"}
                                                    variants={vertLineGridVariants}
                                                    preserveAspectRatio="none"
                                                    ref={vertLeftref}
                                                >
                                                    <motion.path
                                                        key={"ll-"+isPresent}
                                                        initial={!isPresent ? "deep" : "shallow"}
                                                        animate={!isPresent && isProjectExit ? "projExit" : bgCornersActive ? "deep" : "shallow"}
                                                        variants={gridLineVertVariants}
                                                        custom={true}
                                                        style={{ originX: '0%', originY: '50%' }}
                                                        // stroke="var(--grid-lines)"
                                                    />
                                                </motion.svg>
                                            </div>
                                            <div className="grid-line-wrapper"
                                                style={{
                                                    position: "fixed",
                                                    display: "flex",
                                                    height: "110vh",
                                                    bottom: "50%",
                                                    right: 0,
                                                    transform: "translate3d(100%, 50%, 0)"
                                                }}
                                                ref={rightLineRef}  
                                            >
                                                <motion.svg 
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="30" 
                                                    height="100%" 
                                                    viewBox="0 0 30 700" fill="none"
                                                    style={{
                                                        height: "100%",
                                                        transformOrigin: "top"
                                                    }}
                                                    initial="initial"
                                                    animate={!isPresent && !isProjectExit ? "defaultExit" : "animate"}
                                                    variants={vertLineGridVariants}
                                                    preserveAspectRatio="none"
                                                >
                                                    <motion.path
                                                        initial="shallow"
                                                        animate={!isPresent && isProjectExit ? "projExit" : bgCornersActive ? "deep" : "shallow"}
                                                        exit="shallow"
                                                        variants={gridLineVertVariants}
                                                        custom={true}
                                                    />
                                                </motion.svg>
                                            </div>
                                            <div className="grid-line-wrapper"
                                                style={{
                                                    position: "fixed",
                                                    display: "flex",
                                                    height: "100vw",
                                                    bottom: "-15px",
                                                    left: "50%",
                                                    transform: "translate3d(-50%, 50%, 0) rotate(90deg)"
                                                }}
                                                ref={bottomLineRef}  
                                            >
                                                <motion.svg 
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="30" 
                                                    height="100%" 
                                                    viewBox="0 0 30 700" fill="none"
                                                    preserveAspectRatio="none"
                                                    style={{
                                                        height: "100%",
                                                        transformOrigin: "bottom"
                                                    }}
                                                    initial="initial"
                                                    animate={!isPresent && !isProjectExit ? "defaultExit" : "animate"}
                                                    variants={vertLineGridVariants}
                                                >
                                                    <motion.path
                                                        initial="shallow"
                                                        animate={!isPresent && isProjectExit ? "projExit" : bgCornersActive ? "deep" : "shallow"}
                                                        exit="shallow"
                                                        variants={gridLineVertVariants}
                                                        custom={false}
                                                    />
                                                </motion.svg>
                                            </div>
                                            <div className="grid-line-wrapper"
                                                style={{
                                                    position: "fixed",
                                                    display: "flex",
                                                    height: "100vw",
                                                    top: "-15px",
                                                    left: "50%",
                                                    transform: "translate3d(-50%, -50%, 0) rotate(270deg)"
                                                }}
                                                ref={upperLineRef}  
                                            >
                                                <motion.svg 
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="30" 
                                                    height="100%" 
                                                    viewBox="0 0 30 700" fill="none"
                                                    style={{
                                                        height: "100%",
                                                        transformOrigin: "top"
                                                    }}
                                                    initial="initial"
                                                    animate={!isPresent && !isProjectExit ? "defaultExit" : "animate"}
                                                    variants={vertLineGridVariants}
                                                    preserveAspectRatio="none"
                                                    ref={horizUpperRef}
                                                >
                                                    <motion.path
                                                        initial="shallow"
                                                        animate={
                                                            !isPresent && isProjectExit ? "projExit" 
                                                                : bgCornersActive ? "deep" 
                                                                    : "shallow"
                                                        }
                                                        exit="shallow"
                                                        variants={gridLineVertVariants}
                                                        custom={false}
                                                    />
                                                </motion.svg>
                                            </div>
                                        </div>
                                    </motion.div>
                                </AnimatePresence>
                            </motion.div>
                            <div
                                className="project_higlighter_wrapper" 
                                ref={goToUnderlinerRef}
                                onMouseEnter={() => {
                                    if(goToUnderlinerRef.current){
                                        goToUnderlinerRef.current.classList.add("hover_act")
                                    }
                                }}
                                onMouseLeave={() => {
                                    if(goToUnderlinerRef.current){
                                        goToUnderlinerRef.current.classList.remove("hover_act")
                                    }
                                }}
                            >
                            </div>
                        </motion.div>
                        <div className="aux-p-ct">
                            <div className="cm_wrapper">
                                <NewColourMode isColourMode={isColourMode} setIsColourMode={setIsColourMode} initialDelay={0.55} />
                            </div>
                            <AnimatePresence mode="wait" initial={true}>
                                {isPresent &&
                                    <BottomFilter
                                        activeFilter={activeFilter}
                                        setActiveFilter={setActiveFilter}
                                        projData={projData}
                                    />
                                }
                            </AnimatePresence>
                            <div className="bf_bd"/>
                        </div>
                    </>
            }
        </>
    )
}

export default Archive;